/* 文聘（字仲業） */
import { gd, sigOf } from '../../core/kit.ts';
import { defineHero, hook, S, D } from '../define.ts';

export default defineHero({
  id: 'wenpin', name: '文聘', sub: '字仲業', faction: 'wei', role: '坦克', weapon: 'spear',
  look: { beard: 'goatee', bulk: 1.1, shield: true, fx: '#7fc8e8', c: { plume: '#2f6f9a', cape: '#1e3a5a' } },
  skills: [
    ['江夏水軍', 'hook', '擲出鐵錨，命中第一個敵人造成 {70/110/150/190} 傷害並把他拉到身前。', { x: { dmg: [117, 183, 250, 317] }, aim: D(560, 18), cd: 14, mp: 90, el: null }],
    ['偃旗息鼓', 'command', '自己和 400 內的友將隱身 {3/3.5/4/4.5} 秒；從隱身中第一次普攻命中的敵人恐懼 1 秒（以為有伏兵）。', { x: { k: 'ambush', dur: [3, 3.5, 4, 4.5], r: 400, fear: 1 }, aim: S(400), cd: [30, 26, 22, 18], mp: 90, el: 'shadow' }],
    ['石陽堅守', 'passive', '站著不動 1 秒後，受到的傷害 -{12/16/20/24}%。', { pv: {}, sig: 'holdfast', dr: [12, 16, 20, 24] }],
    ['江夏屏障', 'shield', '原地紮根 {3/3.5/4} 秒：受到的傷害 -60%，嘲諷 300 內的敵將；結束時把期間承受傷害的 60% 化為範圍傷害還給周圍敵人。', { x: { k: 'bulwark', dur: [3, 3.5, 4], r: 300, back: 60 }, aim: S(300), cd: [90, 75, 60], mp: [100, 125, 150], el: 'earth', shout: '江夏在此，誰敢過江！' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    ambush(u, a, X) {
      this.units.forEach((t) => {
        if (!t.alive || t.team !== u.team || t.kind !== 'hero' || gd(u.x, u.y, t.x, t.y) > X.r) return;
        t.st.invis = Math.max(t.st.invis, X.dur); t.ambushT = this.t + X.dur + 0.5;
        this.fx({ k: 'puff', x: t.x, y: t.y });
      });
    },
    bulwark(u, a, X) {
      u.bulwarkT = this.t + X.dur; u.bulwarkTaken = 0;
      u.st.root = Math.max(u.st.root, X.dur);
      this.enemiesNear(u, u.x, u.y, X.r).forEach((t) => { if (t.kind === 'hero') this.applyCC(u, t, { taunt: X.dur }); });
      this.fx({ k: 'slam', x: u.x, y: u.y, col: '#7fc8e8' });
      this.later(X.dur, () => {
        if (!u.alive) return;
        const d = u.bulwarkTaken * X.back / 100;
        if (d > 0) this.enemiesNear(u, u.x, u.y, X.r).forEach((t) => this.damage(u, t, d, { magic: true, spell: true, stagger: 0.4 }));
        this.fx({ k: 'slam', x: u.x, y: u.y, col: '#7fc8e8' });
      });
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 江夏屏障：期間只受 40% 傷害
    hook('damage.before', 10, function (c) { if (c.t.bulwarkT > this.t) c.a *= 0.4; }),
    // 石陽堅守：站著不動 1 秒以上減傷
    hook('damage.before', 20, function (c) { const hold = sigOf(c.t, 'holdfast'); if (hold && c.t.stillT >= 1) c.a *= 1 - hold.v('dr') / 100; }),
    // 江夏屏障：記錄期間受到的傷害，結束時反彈
    hook('damage.after', 40, function (c, lost) { if (c.t.bulwarkT > this.t) c.t.bulwarkTaken += lost; }),
    // 偃旗息鼓：伏兵現身的第一擊讓目標恐懼
    hook('attack', 80, function (u, a, next) {
      const t = a.target;
      const amb = u.ambushT > this.t && u.st.invis > 0;
      next();
      if (amb && t && t.alive && t.team !== u.team) { u.ambushT = 0; this.applyCC(u, t, { fear: 1 }); this.fx({ k: 'puff', x: t.x, y: t.y }); }
    }),
    // 石陽堅守：記錄站著不動多久了
    hook('step.hero', 10, function (u, dt) { if (u.sg && u.sg.holdfast) { const m = u.lastPos ? Math.hypot(u.x - u.lastPos[0], u.y - u.lastPos[1]) : 99; u.stillT = m < 0.5 ? (u.stillT || 0) + dt : 0; u.lastPos = [u.x, u.y]; } }),
    hook('revive', 60, function (u) { u.bulwarkT = 0; }),
  ],
  // 電腦什麼時候放這招
  ai: {
    ambush: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d > 150 && d < 700,
    bulwark: ({ w, u, t, d, hero, hpR, foeHeroes }) => foeHeroes(300) >= (hpR < 0.6 ? 1 : 2),
  },
});
